/**
 * Package: nfosongcycleOS
 *
 * NFO Song Cycle overlay scrollbars support and methods
 */

/**
 * Safe(r) shortcut for jQuery.
 */
if ( !$j ) {
    var $j = jQuery.noConflict();
}
        
// Same guard as the GSAP module - the library is not enqueued everywhere,
// and a throw here would take the rest of assets/js/main.js with it.
var OverlayScrollbars = ( 'undefined' === typeof OverlayScrollbarsGlobal )
    ? null
    : OverlayScrollbarsGlobal.OverlayScrollbars;

var nfosongcycleOS = {
    /**
     * Initialize on document ready: init scrollbars
     *
     * @return void
     */
    init: function() {
        nfosongcycleOS.initMobileScrollbars();
        
        // Run methods that need to know about resize
        $j( window ).on( 'resize', function() {
            
        } );
    },

    /**
     * Initializes overlay scrollbars
     *
     * @return void
     */
    initMobileScrollbars: function() {

        if ( !OverlayScrollbars ) return;

        var h_scrolling = $j('.h-scrollbars');

        h_scrolling.each( function( index ) {

            OverlayScrollbars( this, {
                overflow: {
                    x: 'scroll',
                },
            } );

        });

        var v_scrolling = $j('.v-scrollbars');

        v_scrolling.each( function( index ) {

            OverlayScrollbars( this, {
                overflow: {
                    y: 'scroll',
                },
            } );

        });
        
    },
};

// Call init on ready
$j( nfosongcycleOS.init );
